export default __webpack_public_path__ + "static/media/zero_tomate.c37c5d84.png";